export type TemaResuelto = 'oscuro' | 'claro'
export type TemaPreferencia = TemaResuelto | 'auto'

export const APP_THEME_STORAGE_KEY = 'radcore-v2-store'

type PersistedThemeShape = {
  tema?: unknown
  state?: {
    tema?: unknown
  }
}

export function readTemaFromPersistedStore(raw: string | null): TemaPreferencia {
  if (!raw) return 'oscuro'

  try {
    const parsed = JSON.parse(raw) as PersistedThemeShape
    const tema = parsed.state?.tema ?? parsed.tema
    return tema === 'claro' || tema === 'auto' ? tema : 'oscuro'
  } catch {
    return 'oscuro'
  }
}

export function resolveTemaPreferencia(
  tema: TemaPreferencia,
  date: Date = new Date()
): TemaResuelto {
  if (tema !== 'auto') return tema

  const hour = date.getHours()
  return hour >= 7 && hour < 19 ? 'claro' : 'oscuro'
}

export function readTemaFromLocalStorage(storage: Pick<Storage, 'getItem'>): TemaPreferencia {
  return readTemaFromPersistedStore(storage.getItem(APP_THEME_STORAGE_KEY))
}

export function getCurrentTema(): TemaPreferencia {
  if (typeof window === 'undefined') return 'oscuro'
  return readTemaFromLocalStorage(window.localStorage)
}

export function applyThemeClass(
  element: { classList: Pick<DOMTokenList, 'add' | 'remove'> },
  tema: TemaPreferencia
) {
  if (resolveTemaPreferencia(tema) === 'claro') {
    element.classList.remove('dark')
    return
  }

  element.classList.add('dark')
}

export function applyCurrentTheme() {
  if (typeof document === 'undefined') return
  applyThemeClass(document.documentElement, getCurrentTema())
}
